import { loadScript } from './load-script'

const attrs = { async: true }

export const init = () => {
  if (window.fbq) return

  const fbq = window.fbq = function () {
    if (fbq.callMethod) return fbq.callMethod.apply(fbq, arguments)
    fbq.queue.push(arguments)
  }

  if (!window._fbq) window._fbq = fbq

  Object.assign(fbq, { push: fbq, loaded: true, version: '2.0', queue: [] })

  loadScript('https://connect.facebook.net/en_US/fbevents.js', attrs)
  fbq('init', '7279676912104188')
  fbq('track', 'PageView')
}
